import React, { Fragment, useState, useEffect } from "react";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect, withRouter } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { tablePageErrorSelector_9142B_9089 } from "../../SimpleForm/Atoms/Table/selectors";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import GQLUtil from "../../../global/utils/gqlHelper";
import { connect, useDispatch } from "react-redux";
import FormExit from "../../SimpleForm/UI/FormExit";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  GET_9142B_FORM_DATA,
  UPDATE_9142B_FORM,
  SUBMIT_9142B_FORM,
  GET_9142B_PROFILES,
} from "./queries";
import { cleanData } from "./helpers.js";
import renderFormActions from "../renderFormActions";
import renderDeleteButton from "../renderDeleteButton";
import renderSaveButton from "../renderSaveButton";
// import { GET_PROFILES_DATA_H2B } from "../genericQueries";
import util from "../../Utils/mappers";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { buildAllTableErrors } from "../../SimpleForm/Atoms/Table/utils";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

function Form9142B(props) {
  const [profiles, setProfiles] = useState(null);
  const [counties, setCounties] = useState([]);
  const [formData, setFormData] = useState(undefined);
  const [form_ui, setForm_ui] = useState(undefined);
  const useRecaptcha = props.user.Recaptcha !== false;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();

  // profiles, formData, counties, form_ui;
  useEffect(() => {
    const application_type = "9142B";
    const application_id = props.match.params.id;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    dispatch(fetchAllReferenceData());

    let profiles, form;
    const fetchProfiles = async () => {
      profiles = await GQLUtil.genericGQLQuery(print(GET_9142B_PROFILES));
      const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
        profiles.data.getUserProfileInfo,
        application_type,
        "all"
      );
      setProfiles(profiles_parsed);
    };
    fetchProfiles().catch(console.error);

    const fetchFormData = async () => {
      form = await GQLUtil.genericGQLQuery(print(GET_9142B_FORM_DATA), {
        id: application_id,
      });
      if (form.data !== null) {
        let _formData = form.data.getForm9142BById.payload;
        let _form_ui = form.data.getForm9142BById.form_ui;
        setFormData({
          ..._formData,
          formVersionId: form.data.getForm9142BById.formVersionId,
        });
        setForm_ui(_form_ui);
      } else {
        props.history.push("/dashboard/application");
      }
    };
    fetchFormData().catch(console.error);

    util
      .getCounties()
      .then((data) => setCounties(data))
      .catch((e) => console.log(`Unable to fetch counties. ${e}`));
  }, []);

  const Render9142B = () => {
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [closeModal, setcloseModal] = useState(false);
    const [modalOpen, setModalOpen] = useState(true);
    let tablePagesErrors = useRecoilValue(tablePageErrorSelector_9142B_9089);
    const application_type = "9142B";
    const resolverName = "SubmitForm9142B";
    const application_id = props.match.params.id;

    const handleToggle = () => {
      setcloseModal(!closeModal);
    };

    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              props.history,
              values,
              props.user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_9142B_FORM,
              values,
              "Form9142BFormData",
              application_id,
              cleanData,
              props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name,
              tablePagesErrors
            )
          }
          closeModal={closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };

    const formSubmissionError = (e) => {
      setFormSubmitting(false);
      if (e) {
        let error = JSON.stringify(e);
        let type;
        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].extensions
        ) {
          error = e.graphQLErrors[0].extensions;
        }
        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].message
        ) {
          type = e.graphQLErrors[0].message;
        }

        if (
          e &&
          e.networkError &&
          e.networkError.response &&
          e.networkError.response.status &&
          ([400, 500, 503].includes(e.networkError.response.status) ||
            [500].includes(e.networkError.statusCode))
        ) {
          error = "Service is temporarily down. Please try again later.";
        }
        props.history.push({
          pathname: "/dashboard/error",
          state: {
            formType: application_type,
            error: error,
            application_id,
            type,
          },
        });
      }
    };
    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmitting(false);
      props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };
    const processTableAllErrors = formData?.appx_a
      ? buildAllTableErrors(formData.appx_a, "employmentLocations")
      : null;
    return profiles ? (
      <Fragment>
        {!modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={modalOpen}
          >
            {processTableAllErrors}

            <Mutation
              onError={(e) => formSubmissionError(e)}
              onCompleted={(e) => formSubmissionSuccess(e)}
              mutation={SUBMIT_9142B_FORM}
            >
              {(SubmitForm9142B) => (
                <SimpleForm
                  handleSubmit={
                    useRecaptcha
                      ? async (values) => {
                          if (!executeRecaptcha) {
                            return;
                          }
                          const token = await executeRecaptcha(resolverName);
                          SubmitForm9142B({
                            variables: {
                              Form9142BFormData: cleanData(values),
                              id: application_id,
                              token,
                            },
                          });
                        }
                      : (values) => {
                          SubmitForm9142B({
                            variables: {
                              Form9142BFormData: cleanData(values),
                              id: application_id,
                            },
                          });
                        }
                  }
                  toggleClose={handleToggle}
                  toggleModal={handleToggle}
                  formExit={closeModal}
                  renderFormExit={renderFormExit}
                  renderFormActions={renderFormActions(
                    UPDATE_9142B_FORM,
                    "Form9142BFormData",
                    application_id,
                    cleanData,
                    props.history,
                    formSubmitting
                  )} // override default FormActions
                  formSaveMutation={UPDATE_9142B_FORM}
                  formSaveMutationCallback={({
                    formValues,
                    formUIData,
                    saveForm,
                    profilePrefillMetadata,
                  }) => {
                    saveForm({
                      variables: {
                        formUI9142B: formUIData,
                        Form9142BFormData: cleanData(formValues),
                        id: application_id,
                        profilePrefillMetadata: profilePrefillMetadata.profiles,
                      },
                    });
                  }}
                  multiPage={true}
                  uiSchema={UISchemaResolver(application_type)}
                  uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                  uiSchema_nav={UISchemaResolver(`${application_type}-nav`)}
                  uiSchema_lookup={UISchemaResolver(
                    `${application_type}-lookup`
                  )}
                  inputResolver={inputResolver}
                  initialValues={formData || {}}
                  profiles={profiles}
                  counties={counties}
                  form_ui={form_ui}
                  form_ui_name={"formUI9142B"}
                  formSubmitting={formSubmitting}
                  disableValidation={
                    (props.user &&
                      props.user.Roles &&
                      isTester(props.user && props.user.Roles)) ||
                    false
                  }
                  tablePagesErrors={tablePagesErrors}
                />
              )}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    ) : null;
  };

  if (
    formData !== undefined &&
    form_ui !== undefined &&
    profiles !== null &&
    counties?.length !== 0
  ) {
    return (
      <div>
        <Render9142B />
      </div>
    );
  }
  return <FullScreenSpinner />;
}

const mapStateToprops = (props) => {
  return {
    user: props.appReducer.userDataReducer.data,
  };
};

export default withRouter(connect(mapStateToprops, null)(Form9142B));
